



import { defineComponent, inject, onBeforeUnmount, onMounted, PropType, Ref, ref } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { PostFileData } from "@/types";
import { EVENTS } from "@/const";
import PreviewSetupView from "./components/PreviewSetupView";

export default defineComponent({
  name: "PreviewSetupController",
  components: { PreviewSetupView },
  props: {
    postData: { type: Object as PropType<ContentSet>, required: true },
  },
  setup(props) {
    const showConfirm = ref(false);
    const fileList = inject<Ref<PostFileData[]>>("fileList", ref<PostFileData[]>([]));
    const onShow = () => {
      showConfirm.value = true;
    };
    const onCancel = () => {
      showConfirm.value = false;
    };

    const onPreviewSave = async (publicRecord: Record<string, boolean>, cb: Function) => {
      try {
        let changedFiles: ContentFile[] = [];
        await Promise.all(
          fileList.value.map(i => {
            if (i.public === publicRecord[i.id]) return Promise.resolve();
            return providers.ContentFilesProvider.update({
              setId: props.postData.id,
              data: { id: i.id, publicAccess: publicRecord[i.id] },
            }).then(r => {
              changedFiles.push(r);
            });
          })
        );
        emitter.emit(EVENTS.CONTENT_FEED_PREVIEW_CHANGED, changedFiles);
      } finally {
        cb();
        onCancel();
      }
    };

    onMounted(() => {
      emitter.on<any>(EVENTS.CONTENT_FEED_PREVIEW_SHOW, onShow);
    });

    onBeforeUnmount(() => {
      emitter.off<any>(EVENTS.CONTENT_FEED_PREVIEW_SHOW, onShow);
    });

    return {
      fileList,
      showConfirm,
      onCancel,
      onPreviewSave,
    };
  },
});
